import { Paper, Theme } from "@mui/material";
import Box from "@mui/material/Box";
import InfoIcon from '@mui/icons-material/Info';
import React, { useState, useRef } from "react";
import FormLayout from "../../../components/FormLayout";
import SignatureCanvas from "react-signature-canvas";
import { useUser, useCollectionYear } from "../../../hooks/User";
import { useDispatch } from "react-redux";
import { paymentSlice } from "../../../store/reducer/payment";
import CustomButton from "../../../components/CustomButton";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { push } from "redux-first-history";
import AccessibleFormControlLabel from "../../User/components/AccessibleFormControlLabel";

const Signature = () => {
  const dispatch = useDispatch();
  const user = useUser();
  const collectionYear = useCollectionYear();
  const signRef = useRef<SignatureCanvas>(null);
  const [acceptReturn, setAcceptReturn] = useState(false);
  const [showSignPlaceholder, setShowSignPlaceholder] = useState(true);
  const [emptySignature, setEmptySignature] = useState(true);

  const getDescription = () => {
    return `By placing my E-signature on this form I am affirming that this return
    (including the accompanying W-2s, schedules and statements) is a true and
    complete return for the ${collectionYear} tax period. `;
  };

  const handleCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAcceptReturn(event.target.checked);
  };

  const clearSignature = () => {
    //const data = signRef.current?.toData();
    setEmptySignature(true);
    signRef.current?.clear();
    setShowSignPlaceholder(true);
  };

  const signBegins = () => {
    setShowSignPlaceholder(false);
    setEmptySignature(false);
  };

  return (
    <FormLayout
      title={"Signature"}
      subtitle={"confirmation"}
    >
      <Box component="div" className="tip" sx={{display: 'flex', alignItems: 'center'}}>
        <InfoIcon sx={{color: '#008080', height: '1.7rem'}}/>
        <Box component="p" sx={{whiteSpace: 'pre-wrap', margin: '0 0 0 .8rem'}}>
        <b>PC:</b> use mouse to sign.{"\n"}
        <b>Smartphones and tablets:</b> use finger or stylus pen
        to sign.
        </Box>
      </Box>
      <Paper elevation={0} className='paper-container form-layout-container'>
        
        <h2 className="form-compressed-title text-xl title">E-signature</h2>
        <div className='form-static-compressed'>
          <span className='form-static-title'>Name</span>
          <span className='form-static-value'>
            {user?.first_name} {user?.last_name}
          </span>
        </div>
        <div className='form-static-compressed'>
          <span className='form-static-title'>Email</span>
          <span className='form-static-value'>{user?.email}</span>
        </div>
        <p className='form-static-compressed'>{getDescription()}</p>
        <div className='form-static-compressed'>
          <span className='form-static-title'>Attestation</span>
          <FormGroup>
            <FormControlLabel
              control={<Checkbox onChange={handleCheckbox} onKeyUp={(e) => {
                if (e.key === 'Enter') {
                    (e.target as HTMLInputElement).click();
                }
              }}/>}
              label="I agree to the above"
            />
          </FormGroup>
        </div>
        <Box component="div" className='signature-functionality'>
        <div className='signature-container'>
          <div className='signature-row'>
            <div className='signature-label'>
              <SignatureCanvas
                onBegin={signBegins}
                ref={signRef}
                canvasProps={{ className: 'canvas', role: 'region' }}
                clearOnResize={false}
              />
              {showSignPlaceholder && (
                <span className='sign-here'>Sign here</span>
              )}
            </div>
          </div>
        </div>
        <Box component="div" sx={{display: 'flex', alignItems: 'center', padding: '1em'}}>
          <CustomButton
            variant="outlined"
            disableElevation={true}
            label={"Clear Signature"}
            onClick={clearSignature}
            type="button"
          />
        </Box>
        </Box>
      </Paper>
      <div className='btn-container'>
        <CustomButton
          variant="outlined"
          disableElevation={false}
          label={"back"}
          onClick={() => dispatch(push('/balance/review'))}
          buttonSize='btn-lg'
        />
        <CustomButton
          variant="contained"
          disableElevation={true}
          label={"next"}
          onClick={() => dispatch(paymentSlice.actions.confirmSignature({
            signatureRef: signRef,
            acceptReturn: acceptReturn
          }))}
          buttonSize="btn-lg"
        />
      </div>
    </FormLayout>
  );
};

export default Signature;
